export const sampleImages = [
    {
        id: '1497366216548',
        created_at: '2017-06-15T10:30:00-04:00',
        updated_at: '2017-06-15T10:30:00-04:00',
        width: 4000,
        height: 3000,
        color: '#8B9DC3',
        blur_hash: 'L9C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 45,
        liked_by_user: false,
        description: 'Modern office workspace with plants',
        user: {
            id: 'spacejoy123',
            username: 'spacejoy',
            name: 'Spacejoy',
            portfolio_url: 'https://unsplash.com/@spacejoy',
            bio: 'Interior design enthusiast',
            location: 'New York, NY',
            total_likes: 1200,
            total_photos: 150,
            total_collections: 25,
            instagram_username: 'spacejoy',
            twitter_username: 'spacejoy',
            profile_image: {
                small: 'https://images.unsplash.com/profile-1.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-1.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-1.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/spacejoy',
                html: 'https://unsplash.com/@spacejoy',
                photos: 'https://api.unsplash.com/users/spacejoy/photos',
                likes: 'https://api.unsplash.com/users/spacejoy/likes',
                portfolio: 'https://api.unsplash.com/users/spacejoy/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1497366216548-37526070297c',
            full: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1497366216548',
            html: 'https://unsplash.com/photos/1497366216548',
            download: 'https://unsplash.com/photos/1497366216548/download',
            download_location: 'https://api.unsplash.com/photos/1497366216548/download'
        }
    },
    {
        id: '1554118811',
        created_at: '2019-04-01T14:20:00-04:00',
        updated_at: '2019-04-01T14:20:00-04:00',
        width: 3500,
        height: 2333,
        color: '#A67C52',
        blur_hash: 'L8C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 78,
        liked_by_user: false,
        description: 'Cozy coffee shop interior',
        user: {
            id: 'nate_dumlao123',
            username: 'nate_dumlao',
            name: 'Nathan Dumlao',
            portfolio_url: 'https://unsplash.com/@nate_dumlao',
            bio: 'Coffee lover and photographer',
            location: 'Los Angeles, CA',
            total_likes: 2500,
            total_photos: 300,
            total_collections: 40,
            instagram_username: 'nate_dumlao',
            twitter_username: 'nate_dumlao',
            profile_image: {
                small: 'https://images.unsplash.com/profile-2.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-2.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-2.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/nate_dumlao',
                html: 'https://unsplash.com/@nate_dumlao',
                photos: 'https://api.unsplash.com/users/nate_dumlao/photos',
                likes: 'https://api.unsplash.com/users/nate_dumlao/likes',
                portfolio: 'https://api.unsplash.com/users/nate_dumlao/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24',
            full: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1554118811',
            html: 'https://unsplash.com/photos/1554118811',
            download: 'https://unsplash.com/photos/1554118811/download',
            download_location: 'https://api.unsplash.com/photos/1554118811/download'
        }
    },
    {
        id: '1519389950473',
        created_at: '2018-02-20T09:15:00-05:00',
        updated_at: '2018-02-20T09:15:00-05:00',
        width: 4000,
        height: 2667,
        color: '#E8E8E8',
        blur_hash: 'L7C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 156,
        liked_by_user: false,
        description: 'Minimalist desk setup with laptop',
        user: {
            id: 'euwars123',
            username: 'euwars',
            name: 'Farzad Nazifi',
            portfolio_url: 'https://unsplash.com/@euwars',
            bio: 'Minimalist photographer',
            location: 'San Francisco, CA',
            total_likes: 3200,
            total_photos: 200,
            total_collections: 35,
            instagram_username: 'euwars',
            twitter_username: 'euwars',
            profile_image: {
                small: 'https://images.unsplash.com/profile-3.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-3.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-3.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/euwars',
                html: 'https://unsplash.com/@euwars',
                photos: 'https://api.unsplash.com/users/euwars/photos',
                likes: 'https://api.unsplash.com/users/euwars/likes',
                portfolio: 'https://api.unsplash.com/users/euwars/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c',
            full: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1519389950473',
            html: 'https://unsplash.com/photos/1519389950473',
            download: 'https://unsplash.com/photos/1519389950473/download',
            download_location: 'https://api.unsplash.com/photos/1519389950473/download'
        }
    },
    {
        id: '1557683316',
        created_at: '2019-05-12T16:45:00-04:00',
        updated_at: '2019-05-12T16:45:00-04:00',
        width: 3000,
        height: 2000,
        color: '#FF6B6B',
        blur_hash: 'L6C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 89,
        liked_by_user: false,
        description: 'Abstract geometric patterns',
        user: {
            id: 'lucask123',
            username: 'lucask',
            name: 'Lucas K',
            portfolio_url: 'https://unsplash.com/@lucask',
            bio: 'Abstract artist',
            location: 'Berlin, Germany',
            total_likes: 1800,
            total_photos: 120,
            total_collections: 20,
            instagram_username: 'lucask',
            twitter_username: 'lucask',
            profile_image: {
                small: 'https://images.unsplash.com/profile-4.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-4.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-4.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/lucask',
                html: 'https://unsplash.com/@lucask',
                photos: 'https://api.unsplash.com/users/lucask/photos',
                likes: 'https://api.unsplash.com/users/lucask/likes',
                portfolio: 'https://api.unsplash.com/users/lucask/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1557683316-973673baf926',
            full: 'https://images.unsplash.com/photo-1557683316-973673baf926?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1557683316-973673baf926?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1557683316-973673baf926?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1557683316-973673baf926?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1557683316',
            html: 'https://unsplash.com/photos/1557683316',
            download: 'https://unsplash.com/photos/1557683316/download',
            download_location: 'https://api.unsplash.com/photos/1557683316/download'
        }
    },
    {
        id: '1506905925346',
        created_at: '2017-10-01T11:30:00-04:00',
        updated_at: '2017-10-01T11:30:00-04:00',
        width: 5000,
        height: 3333,
        color: '#87CEEB',
        blur_hash: 'L5C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 234,
        liked_by_user: false,
        description: 'Serene lake with mountains',
        user: {
            id: 'cristinagottardi123',
            username: 'cristinagottardi',
            name: 'Cristina Gottardi',
            portfolio_url: 'https://unsplash.com/@cristinagottardi',
            bio: 'Landscape photographer',
            location: 'Switzerland',
            total_likes: 4500,
            total_photos: 400,
            total_collections: 60,
            instagram_username: 'cristinagottardi',
            twitter_username: 'cristinagottardi',
            profile_image: {
                small: 'https://images.unsplash.com/profile-5.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-5.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-5.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/cristinagottardi',
                html: 'https://unsplash.com/@cristinagottardi',
                photos: 'https://api.unsplash.com/users/cristinagottardi/photos',
                likes: 'https://api.unsplash.com/users/cristinagottardi/likes',
                portfolio: 'https://api.unsplash.com/users/cristinagottardi/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4',
            full: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1506905925346',
            html: 'https://unsplash.com/photos/1506905925346',
            download: 'https://unsplash.com/photos/1506905925346/download',
            download_location: 'https://api.unsplash.com/photos/1506905925346/download'
        }
    },
    {
        id: '1449824913935',
        created_at: '2015-12-10T15:20:00-05:00',
        updated_at: '2015-12-10T15:20:00-05:00',
        width: 4000,
        height: 2667,
        color: '#FFA500',
        blur_hash: 'L4C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 567,
        liked_by_user: false,
        description: 'Urban cityscape at golden hour',
        user: {
            id: 'jannerboy62123',
            username: 'jannerboy62',
            name: 'Nick Fewings',
            portfolio_url: 'https://unsplash.com/@jannerboy62',
            bio: 'Urban photographer',
            location: 'London, UK',
            total_likes: 3200,
            total_photos: 250,
            total_collections: 45,
            instagram_username: 'jannerboy62',
            twitter_username: 'jannerboy62',
            profile_image: {
                small: 'https://images.unsplash.com/profile-6.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-6.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-6.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/jannerboy62',
                html: 'https://unsplash.com/@jannerboy62',
                photos: 'https://api.unsplash.com/users/jannerboy62/photos',
                likes: 'https://api.unsplash.com/users/jannerboy62/likes',
                portfolio: 'https://api.unsplash.com/users/jannerboy62/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000',
            full: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1449824913935',
            html: 'https://unsplash.com/photos/1449824913935',
            download: 'https://unsplash.com/photos/1449824913935/download',
            download_location: 'https://api.unsplash.com/photos/1449824913935/download'
        }
    },
    {
        id: '1513475382585',
        created_at: '2017-12-18T13:45:00-05:00',
        updated_at: '2017-12-18T13:45:00-05:00',
        width: 3500,
        height: 2333,
        color: '#DDA0DD',
        blur_hash: 'L3C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 123,
        liked_by_user: false,
        description: 'Creative workspace with art supplies',
        user: {
            id: 'kellysikkema123',
            username: 'kellysikkema',
            name: 'Kelly Sikkema',
            portfolio_url: 'https://unsplash.com/@kellysikkema',
            bio: 'Creative photographer',
            location: 'Amsterdam, Netherlands',
            total_likes: 2100,
            total_photos: 180,
            total_collections: 30,
            instagram_username: 'kellysikkema',
            twitter_username: 'kellysikkema',
            profile_image: {
                small: 'https://images.unsplash.com/profile-7.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-7.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-7.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/kellysikkema',
                html: 'https://unsplash.com/@kellysikkema',
                photos: 'https://api.unsplash.com/users/kellysikkema/photos',
                likes: 'https://api.unsplash.com/users/kellysikkema/likes',
                portfolio: 'https://api.unsplash.com/users/kellysikkema/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0',
            full: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1513475382585',
            html: 'https://unsplash.com/photos/1513475382585',
            download: 'https://unsplash.com/photos/1513475382585/download',
            download_location: 'https://api.unsplash.com/photos/1513475382585/download'
        }
    },
    {
        id: '1507525428034',
        created_at: '2017-10-10T16:30:00-04:00',
        updated_at: '2017-10-10T16:30:00-04:00',
        width: 4500,
        height: 3000,
        color: '#00CED1',
        blur_hash: 'L2C%a7IoIVxZ_NM|M{s:%hRjWAo0',
        likes: 345,
        liked_by_user: false,
        description: 'Tropical beach with palm trees',
        user: {
            id: 'jeremybishop123',
            username: 'jeremybishop',
            name: 'Jeremy Bishop',
            portfolio_url: 'https://unsplash.com/@jeremybishop',
            bio: 'Travel photographer',
            location: 'Hawaii, USA',
            total_likes: 5600,
            total_photos: 500,
            total_collections: 80,
            instagram_username: 'jeremybishop',
            twitter_username: 'jeremybishop',
            profile_image: {
                small: 'https://images.unsplash.com/profile-8.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=32&w=32',
                medium: 'https://images.unsplash.com/profile-8.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=64&w=64',
                large: 'https://images.unsplash.com/profile-8.jpg?q=80&fm=jpg&crop=faces&fit=crop&h=128&w=128'
            },
            links: {
                self: 'https://api.unsplash.com/users/jeremybishop',
                html: 'https://unsplash.com/@jeremybishop',
                photos: 'https://api.unsplash.com/users/jeremybishop/photos',
                likes: 'https://api.unsplash.com/users/jeremybishop/likes',
                portfolio: 'https://api.unsplash.com/users/jeremybishop/portfolio'
            }
        },
        current_user_collections: [],
        urls: {
            raw: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e',
            full: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=75&fm=jpg',
            regular: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=75&fm=jpg&w=1080&fit=max',
            small: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=75&fm=jpg&w=400&fit=max',
            thumb: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=75&fm=jpg&w=200&fit=max'
        },
        links: {
            self: 'https://api.unsplash.com/photos/1507525428034',
            html: 'https://unsplash.com/photos/1507525428034',
            download: 'https://unsplash.com/photos/1507525428034/download',
            download_location: 'https://api.unsplash.com/photos/1507525428034/download'
        }
    }
];
